import { gql } from '@apollo/client';

export function getCertificatePolicyDetailsQuery() {
  return gql`
    query getCertificatePolicyDetails($policyId: String!) {
      Production {
        entities {
          policy(id: $policyId) {
            views {
              Production_all {
                properties {
                  PolicyExpiryDate
                  PolicyIssueDate
                  PolicyNumber
                  PolicyName
                }
              }
            }
          }
        }
      }
      Accounting_ParentBillCategoryList: __type(
        name: "Accounting_ParentBillCategoryList"
      ) {
        name
        enumValues {
          name
        }
      }
      Accounting {
        queries {
          GetPolicyCertificatesBills(ParentPolicyID: $policyId) {
            parentBill_ParentBillCategory
            parentBill_PolicyID {
              views {
                Production_all {
                  properties {
                    PolicyNumber
                    CertificateNumber
                  }
                }
              }
            }
            parentBill_Id
            parentBill_TotalPremium
            parentBill_TotalAmountDue
            parentBill_TotalAmountReceived
            parentBill_TotalCommission
            parentBill_TotalTaxOnCommission
            parentBill_TotalAmountPaid
            parentBill_Currency {
              Symbol
            }
            accounting_Bills_BillNumber
            accounting_Bills_Id
            accounting_Bills_DueDate
            accounting_Bills_TotalPremium
            accounting_Bills_AmountDue
            accounting_Bills_TotalCommission
            accounting_Bills_TaxOnCommission
            payableBills_AmountPaid
            accounting_Bills_AmountReceived
            accounting_Bills_Currency {
              Symbol
            }
            linkedAmendment_AmendmentNumber
            linkedAmendment_AmendmentEffectiveDate
            linkedAmendment_Id
          }
        }
      }
    }
  `;
}
